<!--联系我们-->
<template>
  <div class="new-box">
    <div class="page-banner flex-column-c-c">
      <div class="red-zz"></div>
      <div class="banner-title">联系我们</div>
      <div class="banner-line"></div>
    </div>
    <div class="contact-box flex">
      <div class="contact-gard flex-wrap pr">
        <div class="gard-item flex-column-c-c">
          <div class="item-icon"><img class="img-scale" src="../assets/contact/contact_icon1.png" alt=""></div>
          <div class="item-text">{{baseInfo.web_address}}</div>
        </div>
        <div class="gard-item flex-column-c-c">
          <div class="item-icon"><img class="img-scale" src="../assets/contact/contact_icon2.png" alt=""></div>
          <a class="item-text" :href="`tel:${baseInfo.web_tel}`">{{baseInfo.web_tel}}</a>
        </div>
        <div class="gard-item flex-column-c-c">
          <div class="item-icon"><img class="img-scale" src="../assets/contact/contact_icon3.png" alt=""></div>
          <div class="item-text">{{baseInfo.web_email}}</div>
        </div>
        <div class="gard-item flex-column-c-c">
          <div class="item-icon"><img class="img-scale" src="../assets/contact/contact_icon4.png" alt=""></div>
          <a class="item-text" target="_blank" :href="baseInfo.web_home">{{baseInfo.web_home}}</a>
        </div>
        <div class="gard-dh">
          <img class="img-cover" src="../assets/contact/contact_douhao.png" alt="">
        </div>
      </div>
      <div class="contact-right">
        <baidu-map class="contact-map" :center="{lng: baseInfo.web_long_lat[0] ,lat: baseInfo.web_long_lat[1]}" :zoom="15">
          <bm-marker :position="{lng: baseInfo.web_long_lat[0] ,lat: baseInfo.web_long_lat[1]}" :icon="{url: require('@/assets/contact/contact_address.png'),size:{width:49,height:57}}" animation="BMAP_ANIMATION_BOUNCE" @click="handleOpen(baseInfo.web_long_lat)">
            <bm-label :content="baseInfo.web_site_title" :labelStyle="{color: '#fff', fontSize : '16px',border: none,background:'#9d473a',borderRadius:'50px',padding: '12px 26px',}" :offset="{width: -110, height: 50}" v-if="documentWidth > 750"/>
            <bm-label :content="baseInfo.web_site_title" :labelStyle="{color: '#fff', fontSize : '14px',border: none,background:'#9d473a',borderRadius:'50px',padding: '8px 20px',}" :offset="{width: -90, height: 50}" v-else/>
          </bm-marker>
        </baidu-map>
        <div class="contact-tel margin_left_auto">
          <a class="tel-name" :href="`tel:${baseInfo.web_tel}`">{{baseInfo.web_tel}}</a>
          <div class="tel-text">欢迎咨询24小时为你服务，我们将很快的了解您的需求并及时联系您。</div>
        </div>
      </div>
    </div>
    <MessageFrom></MessageFrom>
    <Footer></Footer>
  </div>
</template>

<script>
  import MessageFrom from "../components/MessageFrom";
  import {ajaxGet, ajaxPost,ajaxUrl} from "../utils/ajax";
  import Footer from "../components/Footer";
  export default {
    name: "Contact",
    data(){
      return {
        ajaxUrl,
        baseInfo: {},
        documentWidth: document.body.clientWidth,
      }
    },
    components: {Footer, MessageFrom},
    mounted() {
      this.$emit('handleRed', false);
      this.fetchBase();
    },
    methods: {
      handleOpen(e) {
        let self = this;
        //景点位置partnerAddress 景点经纬度lng lat
        let lng = e[0];
        let lat = e[1];
        // 高德地图
        if (self.customBrowserVersion().android) {
          window.location.href = "androidamap://viewMap?sourceApplication=appname&poiname=" + self.baseInfo.web_site_title +
            "&lat=" + lat + "&lon=" + lng + "&dev=0";
          //判断是否跳转
          setTimeout(function () {
            let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||
              window.document.webkitHidden;
            if (typeof hidden == "undefined" || hidden == false) {
              //调用高德地图
              window.location.href = "https://uri.amap.com/marker?position=" + lng + "," + lat +
                "&name=" + self.baseInfo.web_site_title;
            }
          }, 100);
        } else if (self.customBrowserVersion().ios) {
          window.location.href = "iosamap://viewMap?sourceApplication=appname&poiname=" + self.baseInfo.web_site_title +
            "&lat=" + lat + "&lon=" + lng + "&dev=0";
          //判断是否跳转
          setTimeout(function () {
            let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||
              window.document.webkitHidden;
            if (typeof hidden == "undefined" || hidden == false) {
              //调用高德地图
              window.location.href = "https://uri.amap.com/marker?position=" + lng + "," + lat +
                "&name=" + self.baseInfo.web_site_title;
            }
          }, 100);
        }
      },
      //区分设备
      customBrowserVersion() {
        var u = navigator.userAgent;
        return {
          trident: u.indexOf('Trident') > -1, //IE内核
          presto: u.indexOf('Presto') > -1, //opera内核
          webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
          iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
          iPad: u.indexOf('iPad') > -1, //是否iPad
          webApp: u.indexOf('Safari') == -1, //是否web应用程序，没有头部与底部
          weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
          qq: u.match(/\sQQ/i) == " qq", //是否QQ
          isBaidu: u.indexOf('baiduboxapp') !== -1, //是否为百度浏览器
          isqqBrowser: u.indexOf('mqqbrowser') !== -1, //是否为qq浏览器
          isWxBrowser: u.indexOf('micromessenger') !== -1, //是否为微信浏览器
          isUc: u.indexOf('ucbrowser') !== -1, //是否为uc浏览器
        };
      },
      /*handleOpen(e){
        window.open(`http://api.map.baidu.com/direction?origin=latlng:${e[0]},${e[1]}|name:我的位置&destination=latlng:${e[0]},${e[1]}|name:${this.baseInfo.web_site_title}&mode=driving®ion=上海&output=html&src=${this.baseInfo.web_site_title}|yourAppName`);
      },*/
      fetchBase(){
        ajaxGet({
          url: `${this.ajaxUrl}api/common/getConfig`,
          params:{},
          success(res){
            const {code, data, msg} = res;
            if(code === 200) {
              this.baseInfo = data.config_list;
            }
          },
        },this);
      },
    },
  }
</script>

<style scoped lang="scss">
  .new-box {
    width: 100%;background: $color-white;
    .page-banner {
      width: 100%;height: 610px;background: url('../assets/partner/partner_banner.png') no-repeat center/cover;padding-top: 2%;position: relative;
      .red-zz { position: absolute;width: 100%;height: 240px;background: linear-gradient(180deg,rgba($theme-color,.7),transparent);top: 0;left: 0;z-index: 2;}
      .banner-title { font-size: 60px;color: $color-white;letter-spacing: 1px;}
      .banner-line { width: 110px;height: 3px;background: $color-white;margin-top: 50px;}
    }
    .contact-box {
      width: 100%;padding: 150px 100px 100px;background: url('../assets/contact/contact_bg.png') no-repeat left bottom;
      .contact-gard {
        flex: 0 0 35%;margin: 22px 0 0 50px;
        .gard-dh { position: absolute;width: 168px;height: 134px;left: -130px;top: -70px;}
        .gard-item {
          width: 50%;padding: 30px 20px;
          &:first-child { border-right: 1px solid #EEEEEE;border-bottom: 1px solid #eeeeee;}
          &:nth-child(2) { border-bottom: 1px solid #eeeeee;}
          &:nth-child(3) { border-right: 1px solid #eeeeee;}
          .item-icon {
            height: 78px;
          }
          .item-text { font-size: $font-size18;height: 54px;}
        }
      }
      .contact-right {
        margin-left: 128px;flex: 1 1 auto;
        .contact-map { width: 100%;height: 491px;background: #ddd;}
        .contact-tel {
          width: 400px;margin-top: 100px;
          .tel-name { font-size: 40px;line-height: 1.3;font-weight: bold;}
          .tel-text { font-size: $font-size18;margin-top: 16px;}
        }
      }
    }
  }
  @media screen and (max-width: 750px) {
    .new-box {
      .page-banner {
        height: 220px;padding-bottom: 0;padding-top: 8%;
        .banner-en { display: none;}
        .banner-title { font-size: 26px;position: relative;z-index: 3;}
        .banner-line { width: 50px;height: 2px;margin-top: 10px;position: relative;z-index: 3;}
      }
      .contact-box {
        padding: 24px 14px;display: block;
        .gard-dh { display: none;}

        .contact-gard {
          margin: 10px 0;width: 100%;
          .gard-item {
            padding: 10px 4px;
            .item-icon { height: 40px;}
            .item-text { height: 50px;font-size: 14px;}
            &:first-child { .item-text { font-size: 12px;}}
          }
        }
        .contact-right {
          width: 100%;margin: 10px 0;
          .contact-map { height: 220px;box-shadow: 0 2px 10px 0 rgba(0,0,0,.15);}
          .contact-tel {
            width: 100%;margin-top: 60px;margin-bottom: 20px;
            .tel-name { font-size: 30px;}
            .tel-text { font-size: 14px;margin-top: 5px;}
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue